import { HTTPError } from 'ky';

function isInvalidEmailMessage(message: string) {
  return /must match format ["']email["']/i.test(message) || /invalid email/i.test(message);
}

function isInvalidOtpMessage(message: string) {
  return /invalid/i.test(message);
}

function isExpiredOtpMessage(message: string) {
  return /expired/i.test(message);
}

async function extractApiErrorMessage(error: HTTPError) {
  try {
    const response = (await error.response.clone().json()) as {
      error?: {
        message?: string;
      };
    };

    return response.error?.message ?? null;
  } catch {
    return null;
  }
}

export async function formatOtpFlowError(
  error: unknown,
  options: {
    invalidEmail: string;
    invalidCode: string;
    expiredCode: string;
    unavailable: string;
    generic: string;
  },
) {
  if (error instanceof HTTPError) {
    const apiMessage = await extractApiErrorMessage(error);

    if (apiMessage) {
      if (isInvalidEmailMessage(apiMessage)) {
        return options.invalidEmail;
      }

      if (isInvalidOtpMessage(apiMessage)) {
        return options.invalidCode;
      }

      if (isExpiredOtpMessage(apiMessage)) {
        return options.expiredCode;
      }
    }

    if (error.response.status >= 500) {
      return options.unavailable;
    }
  }

  if (error instanceof Error) {
    if (isInvalidEmailMessage(error.message)) {
      return options.invalidEmail;
    }

    if (isInvalidOtpMessage(error.message)) {
      return options.invalidCode;
    }

    if (isExpiredOtpMessage(error.message)) {
      return options.expiredCode;
    }
  }

  return options.generic;
}
